export const productMapping = {
    'tax-free-savings': 'TFSA',
    'living-annuity': 'LA',
    'offshore-foreign-currency-funds': 'GIB',
    'offshore-rand-based-funds': 'INVIB',
    retirement: 'INVRA',
    'unit-trusts': 'INVIB',
};
